import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledInput } from './styled.mjs';

const PrimitiveInput = forwardRef(
  (props, ref) => {
    const { children, ...rootProps } = props;
    return /* @__PURE__ */ jsx(StyledInput, { ref, spellCheck: false, ...rootProps, children });
  }
);

export { PrimitiveInput as default };
//# sourceMappingURL=PrimitiveInput.mjs.map
